import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const Container = styled('div')({
  padding: '0px 0px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const NavButton = styled(Button)({
  overflowWrap: 'break-word',
  color: '#00008f',
});

export const DrawerButton = styled(NavButton)({
  justifyContent: 'normal',
  color: '#00008F',
});
